import type { IPortalClient } from "./iPortalClient";
import { ChannelsClient } from "../domains/channels/channels.client";
import { ServiceClient } from "../domains/service/service.client";
import { DriversClient } from "../domains/drivers/drivers.client";
import { FiltersClient } from "../domains/filters/filters.client";
import { LisClient } from "../domains/lis/lis.client";
import { SamplesClient } from "../domains/samples/samples.client";
import { PendingClient } from "../domains/pending/pending.client";
import { TestsClient } from "../domains/tests/tests.client";
import { LocationsClient } from "../domains/locations/locations.client";
import { InstrumentsClient } from "../domains/instruments/instruments.client";
import { SettingsClient } from "../domains/settings/settings.client";
import { PanelMappingsClient } from "../domains/panel-mappings/panel-mappings.client";
import { PanelTestsClient } from "../domains/panel-tests/panel-tests.client";
import { SampleTypesClient } from "../domains/sample-types/sample-types.client";
import { FlagsClient } from "../domains/flags/flags.client";
import { RightsClient } from "../domains/rights/rights.client";
import { PanelsClient } from "../domains/panels/panels.client";

export class ProdCoreClient implements IPortalClient {
  channels: ChannelsClient;
  service: ServiceClient;
  drivers: DriversClient;
  filters: FiltersClient;
  lis: LisClient;
  samples: SamplesClient;
  pending: PendingClient;
  tests: TestsClient;
  locations: LocationsClient;
  instruments: InstrumentsClient;
  settings: SettingsClient;
  panelMappings: PanelMappingsClient;
  panelTests: PanelTestsClient;
  sampleTypes: SampleTypesClient;
  flags: FlagsClient;
  rights: RightsClient;
  panels: PanelsClient;

  constructor(baseUrl: string, token: string | null) {
    this.channels = new ChannelsClient(baseUrl, token);
    this.service = new ServiceClient(baseUrl, token);
    this.drivers = new DriversClient(baseUrl, token);
    this.filters = new FiltersClient(baseUrl, token);
    this.lis = new LisClient(baseUrl, token);
    this.samples = new SamplesClient(baseUrl, token);
    this.pending = new PendingClient(baseUrl, token);
    this.tests = new TestsClient(baseUrl, token);
    this.locations = new LocationsClient(baseUrl, token);
    this.instruments = new InstrumentsClient(baseUrl, token);
    this.settings = new SettingsClient(baseUrl, token);
    this.panelMappings = new PanelMappingsClient(baseUrl, token);
    this.panelTests = new PanelTestsClient(baseUrl, token);
    this.sampleTypes = new SampleTypesClient(baseUrl, token);
    this.flags = new FlagsClient(baseUrl, token);
    this.rights = new RightsClient(baseUrl, token);
    this.panels = new PanelsClient(baseUrl, token);
  }
}
